
<div class="main-terms-container" style="margin: 50px;">
    <h4>Sección II. Términos y Condiciones del SaaS</h4>

    <!-- 1. Definiciones -->
    <section>
        <h5>1. Definiciones</h5>
        <p>Las partes entienden y aceptan que para efectos de la interpretación de este contrato y sus anexos
            los siguientes términos significarán lo siguiente:</p>
        <dl>
            <dt>CLIENTE</dt>
            <dd>Es la parte de este contrato que se encuentra interesada en adquirir y
                parametrizar los servicios de la APLICACIÓN SGI 4.0.</dd>
            
            <dt>CIBERINCIDENTE</dt>
            <dd>
                Es un evento no deseado o inesperado que ocurre en un entorno informático o
                en una red de computadoras y que puede vulnerar las medidas de seguridad
                establecidas sobre la información, los sistemas de información, la plataforma
                física, técnica o tecnológica. De manera que se afecte la seguridad,
                disponibilidad, integridad, o confidencialidad de la información, bases de datos,
                datos personales, sistemas de información, servidores y demás arquitectura
                tecnológica.
                Se entiende, en ese sentido, entre otros: 
                (i) el acceso no autorizado un sistema
                o infraestructura de información de la CLIENTE; (ii) la modificación no autorizada
                de la información; (iii) la eliminación no autorizada de la información; (iv) el
                descargo de la información; y (v) cualquier otra acción que afecta a la
                información y/o al sistema o infraestructura de información de la CLIENTE.
                CÓDIGO MALICIOSO Un código malicioso, también conocido como malware (acrónimo de «malicious
                software»), se refiere a cualquier tipo de software diseñado específicamente
                para dañar, comprometer o acceder de manera no autorizada a un sistema
                informático, dispositivo o red.
            </dd>
            
            <dt>CÓDIGO MALICIOSO</dt>
            <dd>Un código malicioso, también conocido como malware (acrónimo de «malicious
                software»), se refiere a cualquier tipo de software diseñado específicamente
                para dañar, comprometer o acceder de manera no autorizada a un sistema
                informático, dispositivo o red.</dd>
            
            <dt>DATOS DE LA CLIENTE</dt>
            <dd>Se trata de toda aquella información o los datos de los que disponga la CLIENTE
                bajo su titularidad o autorización de uso que se carguen o almacenen en la
                APLICACIÓN SGI 4.0.</dd>
            
            <dt>DERECHOS DE PROPIEDAD INTELECTUAL</dt>
            <dd>
                Significan todos los derechos de propiedad (incluyendo sus aspectos
económicos, morales y de cualquier otro tipo) que la LEGISLACIÓN APLICABLE
reconozca sobre las obras del intelecto humano (creaciones, invenciones,
innovaciones, etc.), incluyendo los derechos de autor, esto es, los derechos de
propiedad intelectual sobre los siguientes elementos: módulos de software,
programas de ordenador, aplicaciones, funcionalidades, soluciones y demás
creaciones vinculadas.
            </dd>
            
            <dt>DOCUMENTACIÓN DEL SOFTWARE LICENCIADO</dt>
            <dd>
                Significa toda la documentación que describe la composición, programación,
operatividad, funciones, funcionamiento y demás características o aspectos del
código fuente del Software Licenciado. Esta definición incluye la tecnología
propietaria y otros materiales, componentes, subcomponentes, componentes
de terceros, módulos, archivos de código fuente (incluso de versiones
anteriores), esquemas y scripts de banco de datos, scripts de compilación, datos
de los scripts de prueba, evidencias de pruebas, utilitarios, scripts de prueba,
documentos, manuales, bases de conocimiento, diagramas de enlace,
bibliotecas de software, listados de programa, configuraciones, modelos de
datos, dashboards y flujogramas necesarios para ayudar a un programador
razonablemente calificado a desarrollar, probar, operar, analizar, dar asistencia
y recrear los ambientes de desarrollo y producción referentes a las versiones
anteriores y más recientes del software.
            </dd>
            
            <dt>INTERFAZ DE PROGRAMACIÓN DE APLICACIONES (API)</dt>
            <dd>
                Se refiere a la interfaz segura de programación de aplicaciones que se realizará
entre los sistemas de la CLIENTE y Eficacia en caso de la necesidad de transferencia
de información de los DATOS DE LA CLIENTE.
            </dd>
            
            <dt>LEGISLACIÓN APLICABLE</dt>
            <dd>Significa la legislación vigente en la República de Colombia.</dd>
            
            <dt>SERVICIOS O SERVICIO SAAS</dt>
            <dd>
                Son los servicios que se prestan a través de la <strong>APLICACIÓN SGI 4.0</strong>, que incluyen la gestión de ventas, mercadeo, modificaciones y actualizaciones de software, almacenamiento en la nube, garantías, soporte y mantenimiento, entre otros, conforme a lo descrito en este contrato y sus anexos.
            </dd>
            
            <dt>APLICACIÓN SGI 4.0</dt>
            <dd>
                Consiste en la aplicación a través de la cual tendrán acceso los USUARIOS SGI 4.0
designados por la CLIENTE y parametrizados por el USUARIO ADMINISTRADOR para la
ejecución de los SERVICIOS.
            </dd>
            
            <dt>USUARIOS</dt>
            <dd>
                Son las personas naturales o jurídicas que tendrán acceso a la APLICACIÓN SGI 4.0.
                Podrán ser USUARIO ADMINISTRADOR o USUARIO SGI 4.0
            </dd>
            
            <dt>USUARIO ADMINISTRADOR</dt>
            <dd>
                Es el usuario designado por la CLIENTE para tener acceso a la APLICACIÓN SGI 4.0 para
parametrizar los SERVICIOS.
            </dd>
            <dt>USUARIO SGI 4.0</dt>
            <dd>
                Es cada uno de los usuarios que cree y a los que permita acceso la CLIENTE desde
la APLICACIÓN SGI 4.0 y que han sido previamente parametrizados
            </dd>

            <dt>INFORMACIÓN CONFIDENCIAL</dt>
            <dd>
                Se considerará como confidencial toda información verbal, escrita, digital o
electrónica divulgada por alguna de las partes durante la vigencia de este
contrato, salvo que alguna de las partes indique lo contrario expresamente. El
término INFORMACIÓN CONFIDENCIAL podrá incluir, pero no se limitará a, DATOS DE LA
CLIENTE, DATOS PERSONALES, bases de datos personales, información relacionada
con el código no divulgado de la APLICACIÓN SGI 4.0, aplicaciones y softwares no
divulgadas, diseños, estructuras y arquitecturas de software, el modelo de
negocio, información relacionada con el funcionamiento de las plataforma, la
información técnica, el know how y los secretos empresariales de Eficacia,
procesos, procedimientos, resultados de investigación, protocolos,
descubrimientos, invenciones, ideas de negocio, conceptos, técnicas, diseños,
especificaciones, dibujos, diagramas, datos, programas de computador,
actividades y operaciones comerciales, listas de clientes, bases de datos,
software, planes, programas, proyectos, reportes, informes, estudios y/o
cualquier otra información científica, técnica, administrativa, financiera, legal
y/o comercial o de cualquier otra naturaleza.
            </dd>
            
            <dt>CONVENIO DE PROTECCIÓN DE DATOS PERSONALES</dt>
            <dd>
                Significa el acuerdo que se encuentra en el anexo C de este contrato en donde
las partes pactan cómo se realizará el tratamiento de los datos personales que
las partes tomen acceso en virtud de la negociación, celebración y ejecución de
este contrato. Este convenio deberá respetar la normativa de protección de
datos personales vigente.
            </dd>
            
            <dt>VULNERABILIDAD</dt>
            <dd>
                Cualquier debilidad en (i) el hardware, software, frameware, y/o (ii) los
procedimientos de seguridad automatizados, controles administrativos,
infraestructura física y controles internos críticos, que pueden ser utilizados para
ganar acceso no autorizado a la información o interrumpir procesos.
            </dd>
        </dl>
    </section>

    <!-- 2. Objeto -->
    <section>
        <h5>2. Objeto</h5>
        <p>
            Este contrato tiene por objeto establecer los términos y condiciones respecto de la prestación de
los servicios por Eficacia a la CLIENTE en la APLICACIÓN SGI 4.0, a través de los cuales ofrecerá los
SERVICIOS que se determinen en este documento y en sus anexos
        </p>
    </section>

    <!-- 3. Alcance del objeto -->
    <section>
        <h5>3. Alcance del Objeto</h5>
        <p>
            La CLIENTE declara que entiende, acepta y reconoce que está interesada en acceder y usar la
APLICACIÓN SGI 4.0 y que este es un privilegio exclusivo que Eficacia le concede a sus CLIENTES. Con el
fin de que las partes puedan ejecutar y cumplir a cabalidad con el objeto de este contrato, la cliente
deberá adquirir una MEMBRESÍA de conformidad con las opciones establecidas en el anexo A, que
determinará el alcance de los SERVICIOS a los que tendrá acceso, así como las características técnicas
y funcionales de la APLICACIÓN SGI 4.0.
        </p><p>
Las Partes dejan expresa constancia que la relación contractual que se genera por este Contrato es
de carácter civil y comercial y no configura, bajo supuesto alguno, una relación de derecho laboral
ni entre ellas, ni entre Eficacia y el personal de la CLIENTE. Asimismo, lo establecido en este Contrato
no será considerado como una relación de sociedad, asociación comercial o joint venture entre las
Partes.</p>
    </section>

    <!-- 4. Membresías -->
    <section>
        <h5>4. Membresías</h5>
        <p>
            La CLIENTE deberá adquirir una MEMBRESÍA para el uso y acceso a la APLICACIÓN SGI 4.0, la cual podrá
parametrizarse y gestionarse a través de SGI 4.0. El valor de la MEMBRESÍA que adquiera la CLIENTE
dependerá del número de USUARIOS ADMINISTRADORES y USUARIOS SGI 4.0 que se requieran para cada
caso particular, de los SERVICIOS contratados y de la tipología de usuario que se contrate; es decir,
que la gestión y ejecución del SERVICIO se haga directamente o a través de Eficacia. El precio por
rangos de usuarios se encuentra establecido en el anexo A de este contrato.
        </p>
        <p>
            <strong>Parágrafo:</strong> El valor de la MEMBRESÍA que adquiera la CLIENTE incluirá el acceso a la aplicación móvil
            SGI 4.0 y nube a través de la cual Eficacia prestará los SERVICIOS objeto de este contrato.
        </p>
    </section>

    <!-- 5. Servicios -->
    <section>
        <h5>5. Servicios</h5>
        <p>
            Los servicios de software en la nube que ofrece Eficacia a sus CLIENTES a través de la APLICACIÓN SGI 4.0
se encuentran enfocados en equipo de ejecución de estrategias de punto de venta y equipos con
roles comerciales como vendedores y promotores. El servicio principal se enfoca en el modelo de
reportería estandarizada con tableros genéricos que están dentro de LA APLICACIÓN SGI 4.0 y
reportería plana para descargar en formatos de Excel y CSV.


        </p>

            <p>
                Los SERVICIOS en la nube que se ejecutan en la APLICACIÓN SGI 4.0 son los que se describen a
continuación:
            </p>
                <ol>
                    <li><strong>5.1 Gestión de mercadeo:</strong>Eficacia ofrece el servicio de gestión para las actividades
                        relacionadas con el punto de venta, dentro de las cuales se encuentra la opción de
                        gestionar los indicadores de agotados, inventario, precios, cobertura y captura;</li>
                    <li> <strong>5.2 Gestión de ventas:</strong>Eficacia ofrece el servicio de gestión para las actividades relacionadas
                        con los equipos comerciales en campo, dentro de las cuales se encuentra la opción de
                        gestionar los indicadores de agotados, inventario, precios, cobertura y captura.</li>
                </ol>
            
        <p>
            La descripción detallada de los servicios que se acabaron de mencionar se encuentra en el anexo A
de este Contrato, que es parte íntegra del mismo y por lo tanto es de obligatorio cumplimiento para
las partes. Lo anterior sin perjuicio de que Eficacia pueda establecer otros servicios parametrizables
ejecutables en la APLICACIÓN SGI 4.0, los cuales se actualizarán en la presentación comercial de
Eficacia incluida en el anexo A, la cual podrá ser motivo de renegociación de la MEMBRESÍA que
adquiera la CLIENTE.
        </p>
        
        <p>
            <strong>Parágrafo primero:</strong> Disponibilidad del SERVICIO. Eficacia se compromete a proporcionar el Servicio
            SaaS de manera continua y con una disponibilidad mayor o igual a 99% a excepción de los supuestos
            contemplados en el presente documento.
        </p>
        <p>
            <strong>Parágrafo segundo:</strong> Soporte y mantenimiento. El servicio de soporte y mantenimiento para la
            APLICACIÓN SGI 4.0 se encuentra detallado en el anexo B de este contrato, que es parte integral del
            presente documento y por lo tanto es de obligatorio cumplimiento para las partes.
        </p>
    </section>

    <!-- 6. Obligaciones de la CLIENTE -->
    <section>
        <h5>6. Obligaciones de la CLIENTE</h5>
        <p>Las siguientes serán las obligaciones de la CLIENTE:</p>
        <ol>
           <li><strong>6.1.</strong>  Usar la APLICACIÓN SGI 4.0 solamente para acceder y usar los servicios incluidos en este
            Contrato.</li> 
            <li><strong>6.2</strong> Adquirir y pagar la membresía a Eficacia oportunamente, de conformidad con los precios y
                formas de pago establecidos en el anexo A de este contrato. En caso de que la CLIENTE no
                ejecute de manera oportuna alguna de las obligaciones a su cargo, aquél quedará
                automáticamente constituido en mora, sin que sea necesario el requerimiento por parte
                de Eficacia. En el evento de retraso, pago parcial o no pago del valor acordado en dicha
                cláusula, la CLIENTE entiende y acepta que Eficacia podrá también:
                6.2.1. Suspender el acceso a la APLICACIÓN SGI 4.0.
                6.2.2. Dar por terminado unilateralmente y de forma anticipada este contrato y proceder
                con la solicitud de pago por indemnización por los daños y perjuicios causados e iniciar
                las acciones civiles, penales, contractuales o administrativas que considere
                pertinentes o conducentes.</li>

            <li> <strong>6.3</strong> Cumplir con las obligaciones en materia de protección de datos personales conforme al
                anexo C; </li>

            <li> <strong>6.4</strong> La CLIENTE se compromete a utilizar el servicio de software como servicio (SaaS)
                proporcionado por Eficacia de manera adecuada y conforme a los términos y condiciones
                acordados. La CLIENTE se abstendrá de utilizar el SaaS para cualquier actividad ilegal,
                fraudulenta, difamatoria o que pueda causar daño a terceros. </li>

            <li><strong>6.5</strong> Mantener la reserva de la INFORMACIÓN CONFIDENCIAL entregada, suministrada o a las que se
                permita o facilite acceso o uso por Eficacia, ya sea de propiedad de Eficacia o de terceros
                en relación con los cuales tenga obligación de confidencialidad, y tomar las medidas
                razonables para mantenerla secreta y confidencial, incluyendo seguir y adoptar los
                instructivos, manuales, protocolos o procedimientos que sean entregados, divulgados o
                puestos en su conocimiento durante la vigencia de este contrato;
                </li>

            <li><strong>6.6</strong> La CLIENTE será responsable de mantener la confidencialidad de las credenciales de acceso
                proporcionadas por Eficacia. La CLIENTE no divulgará sus credenciales de acceso a terceros
                y se compromete a tomar las medidas necesarias para evitar cualquier acceso no
                autorizado a su cuenta.</li>

            <li><strong>6.7</strong> No usar, almacenar o usufructuar la APLICACIÓN SGI 4.0 para propósitos diferentes a los aquí
                autorizados.
            </li>

            <li><strong>6.8</strong> Permitir el uso o acceso a la APLICACIÓN SGI 4.0 solamente a las personas autorizadas (sean
                estas personas naturales o jurídicas), conforme a la MEMBRESÍA adquirida. El acceso a la
                APLICACIÓN SGI 4.0 por personas adicionales o diferentes a las autorizadas se considerará
                como incumplimiento de este contrato y podrá dar lugar a la terminación anticipada de
                este contrato. </li>

            <li><strong>6.9</strong> No usar la APLICACIÓN SGI 4.0 para usos o propósitos no permitidos o que exceden el alcance
                de este contrato que puedan ser considerados ilegales, delitos, fraudulentos o prohibidos
                por la ley nacional o internacional o en conexión con actividades de sus clientes, empleados
                o usuarios autorizados que puedan ser considerados ilegales, fraudulentos, delitos o
                prohibidos por la ley nacional o internacional. En el evento de que la CLIENTE lleve a cabo
                directa o indirectamente, ya sea por acción u omisión, algún uso o permita que terceros lo
                usen para actividades que se puedan considerar ilegales, fraudulentas, delitos o prohibidas
                por la ley nacional o internacional, Eficacia podrá dar por terminado unilateralmente este
                contrato y se reserva el derecho a demandar a la CLIENTE y exigir una indemnización por los
                daños y perjuicios causados e iniciar las acciones civiles, penales, contractuales o
                administrativas que considere pertinentes o conducentes. La CLIENTE deberá mantener
                indemne de toda responsabilidad civil o penal a Eficacia, sus aliadas, vinculadas, socios,
                empleados o contratistas y salir en defensa y asumir los pagos por los daños, condenas o
                sanciones que le sean aplicados o cobrados a Eficacia por las autoridades judiciales o
                administrativas competentes;</li>
            
                <li><strong>6.10</strong> No llevar a cabo actividades de decompilación, modificación de sus componentes o
                    ingeniería inversa sobre la APLICACIÓN SGI 4.0 durante la vigencia de este contrato y hasta su
                    liquidación e incluso luego de su terminación por cualquier causal aquí establecida. El
                    incumplimiento de esta obligación podrá ser objeto de las acciones civiles, contractuales o
                    penales que sean pertinentes y a elección de Eficacia;</li>

                <li><strong>6.11</strong> No solicitar, registrar, depositar o en general llevar a cabo cualquier acto o permitir o
                    facilitar que terceros lo lleven a cabo para solicitar, tramitar y/u obtener protección de uno
                    o más derechos de propiedad intelectual y propiedad inmaterial asociados a la APLICACIÓN
                    SGI 4.0 y sus bases de datos, algoritmos, manuales, protocolos, metodologías, información,
                    know how o service how de propiedad de Eficacia;</li>

                <li><strong>6.12</strong> La CLIENTE acepta que el servicio de SaaS y cualquier propiedad intelectual asociada,
                    incluyendo software, interfaces, diseños y marcas comerciales, son propiedad exclusiva de
                    Eficacia. La CLIENTE se compromete a no copiar, modificar, distribuir o utilizar dicha
                    propiedad intelectual sin el consentimiento previo por escrito de Eficacia. La CLIENTE es
                    responsable de realizar copias de seguridad de sus datos y asegurarse de contar con
                    medidas adecuadas de seguridad de la información a fin de garantizar la confidencialidad,
                    disponibilidad e integridad de la información que se almacene en la aplicación SGI 4.0.</li>

                <li><strong>6.13</strong> Implementar medidas de seguridad para proteger la red y los sistemas utilizados para el
                    acceso y almacenamiento de la información de los usuarios en la APLICACIÓN SGI 4.0. Esto
                    incluye, entre otros, el uso de cortafuegos, antivirus, sistemas de detección y prevención
                    de intrusiones, y encriptación de datos en tránsito y en reposo.</li>

                <li><strong>6.14</strong> En caso de que se produzca una brecha de seguridad o un ciberincidente, la CLIENTE se
                    compromete a implementar un plan de gestión de incidentes que incluya la notificación
                    oportuna a Eficacia. La CLIENTE tomará medidas para mitigar los efectos de la brecha de
                    seguridad y para evitar incidentes futuros.</li>
                
                <li><strong>6.15</strong> Cumplir con todas las obligaciones en materia de ciberseguridad y seguridad de la
                    información.</li>

                <li><strong>6.16</strong> Adoptar todas las medidas pertinentes para evitar que los mantenimientos programados
                    a la APLICACIÓN SGI 4.0 puedan afectar o causar daño a sus actividades comerciales o su
                    patrimonio, el de sus clientes o terceros. En ningún caso Eficacia será responsable por los
                    daños, perjuicios, pérdida de negocios, afectación o daños causados a la CLIENTE por los
                    mantenimientos programados que realice a la APLICACIÓN SGI 4.0. Las partes acuerdan y
                    aceptan que es responsabilidad de la CLIENTE tomar todas las medidas razonables y
                    necesarias para evitar, prevenir, mitigar o reducir los daños que puedan causarse. La CLIENTE
                    acepta que no podrá hacer responsable o solicitar, judicial o extrajudicialmente, que
                    Eficacia la indemnice por uno o más daños causados por el incumplimiento, negligencia o
                    descuido, por acción u omisión.</li>
        </ol>
        <p><strong>Parágrafo.</strong> La CLIENTE entiende, acepta y acuerda que si sus agentes, empleados, contratistas,
            clientes o terceros con su autorización, permiso, conocimiento o a los que les facilitó acceso a la
            APLICACIÓN SGI 4.0, por acción o por omisión, lleva a cabo usos, aplicaciones, almacenamiento de
            información propia, de sus clientes o terceros no autorizados o por fuera del alcance de este
            contrato, Eficacia no será responsable por los daños o perjuicios que se causen a los USUARIOS o a
            terceros y podrá dar por terminado unilateralmente y de manera inmediata este contrato.
            Asimismo, se reserva el derecho de tomar y llevar a cabo las acciones contractuales, civiles, penales
            o administrativas que considere pertinentes o conducentes para prevenir, controlar, evitar,
            conjurar y obtener indemnización por los daños causados por la CLIENTE o terceros por razón del
            incumplimiento de esta cláusula, incluyendo la aplicación de medidas cautelares en contra de la
            CLIENTE, empleados, contratistas, clientes o terceros.</p>
    </section>

    <!-- 7. Obligaciones de Eficacia -->
    <section>
        <h5>7. Obligaciones de Eficacia</h5>
        <p>Las siguientes serán las obligaciones de Eficacia:</p>
        <ol>
            <li>
                <strong>7.1</strong> Proveer para el acceso, uso y ejecución la APLICACIÓN SGI 4.0 y hacer sus mejores esfuerzos
                para que estén permanentemente disponibles y en condiciones para el uso, acceso y
                ejecución por parte de la CLIENTE, sujeto a las circunstancias que están fuera del control de
                Eficacia, tales como una adecuada conexión a internet, las condiciones y capacidad técnica
                de la red o del proveedor de servicios de internet de la CLIENTE;
            </li>
            <li>
                <strong>7.2</strong> Proveer las medidas razonables y necesarias de protección y seguridad de la información y
                de los datos que sean propiedad de la CLIENTE, sus empleados, aliados, socios o clientes que
                se almacenen o usen en la APLICACIÓN SGI 4.0 que disponga Eficacia para el cumplimiento de
                las obligaciones de este contrato;
            </li>
            <li>
                <strong>7.3</strong> Ofrecer los servicios de soporte y mantenimiento en los términos del anexo B de este
                contrato;
            </li>
            <li>
                <strong>7.4</strong> Hacer todos los esfuerzos razonables desde el punto de vista técnico para poner los
                SERVICIOS a disposición de la CLIENTE con una disponibilidad mínima de 99 %. Eficacia no
                garantiza la disponibilidad de los SERVICIOS en los siguientes casos:
                <ol type="a">
                    <li><strong>7.4.1</strong>  Interrupciones planificadas para mantenimientos programados, los cuales serán
                        notificados a la CLIENTE con anticipación, cuando sea posible.</li>
                    <li><strong>7.4.2</strong>  Interrupciones causadas por acciones u omisiones de la CLIENTE o de terceros
                        autorizados por la CLIENTE, incluyendo errores de configuración, mal uso del servicio,
                        acceso no autorizado o actividades maliciosas.</li>
                    <li><strong>7.4.3</strong>  Interrupciones causadas por fallas o limitaciones de las redes de comunicaciones
                        utilizadas por la CLIENTE para acceder al servicio de SaaS, incluyendo problemas de
                        conectividad a Internet, cortes de energía, o problemas en los dispositivos de la
                        CLIENTE;</li>
                    <li><strong>7.4.4</strong> Cualquier indisponibilidad provocada por circunstancias más allá del control
                        razonable de Eficacia, incluyendo, sin limitarse a ellos, eventos constitutivos de caso
                        fortuito o fuerza mayor, acciones gubernamentales, inundaciones, incendios,
                        terremotos, malestar social, actos de terrorismo, huelgas u otros problemas laborales
                        que no sean aquellos que involucran a sus empleados; daños causados por la CLIENTE
                        y/o sus USUARIOS, fallas o demoras del proveedor del servicio de Internet de la CLIENTE;
                        y</li>
                    <li><strong>7.4.5</strong> Cualquier indisponibilidad por fallas imprevisibles en el servicio del tercero proveedor
                        de servicios en la nube en los que funciona la APLICACIÓN SGI 4.0.</li>
                </ol>
            </li>
        </ol>
    </section>

    <!-- 8. Vigencia -->
    <section>
        <h5>8. Vigencia</h5>
        <p>
            Este contrato tendrá el mismo término de vigencia de la MEMBRESÍA que adquiera la CLIENTE, que
podrá prorrogarse por las partes por el mismo término de común acuerdo, siempre que se renueve
la MEMBRESÍA. Este contrato no se entenderá prorrogado automáticamente si la CLIENTE no renueva
su MEMBRESÍA y, en este caso, el contrato se entenderá finalizado.
        </p>
    </section>

    <!-- 9. Propiedad Intelectual -->
    <section>
        <h5>9. Propiedad Intelectual</h5>
        <p> partes entienden y aceptan que todos los derechos de propiedad intelectual asociados a la
APLICACIÓN SGI 4.0 y a su modelo de negocio son de titularidad de Eficacia o esta se encuentra
autorizada para usar y gestionar uno o más derechos de propiedad intelectual de titularidad de
terceros. La propiedad intelectual y la propiedad inmaterial de Eficacia seguirá siendo de ella
durante y después de la ejecución de este contrato y la CLIENTE acepta, entiende y acuerda no
reclamar, disputar, declarar o solicitar o intentar solicitar, en Colombia o en el exterior, derecho de
propiedad alguno sobre las mismas.</p>
<p>Los derechos de propiedad intelectual asociados a la APLICACIÓN SGI 4.0 de Eficacia se extienden a
    todas las mejoras funcionales que en el futuro se incorporen en el código fuente y/o nuevos
    módulos o software que se desarrolle por Eficacia, sean resultado de este contrato o no.
    La CLIENTE reconoce que este contrato es solo respecto del servicio que se presta a través del
    software y las aplicaciones y plataformas de titularidad de Eficacia y por lo tanto no le concede o
    promete conceder derecho alguno, ni adquirirá, tendrá derecho a adquirir o se le ofrece promesa
    o garantía que podrá adquirir ninguna participación en la titularidad, ni que se le cede, licencia o
    transfiere todo o parte de la propiedad intelectual o inmaterial de Eficacia. Así mismo, la CLIENTE no
    hará, permitirá, llevará a cabo o facilitará actividad alguna de ingeniería inversa sobre los derechos
    de propiedad intelectual o propiedad inmaterial de Eficacia.</p>

    <p>La CLIENTE deberá dar inmediato aviso a Eficacia de cualquier violación o posible violación o atentado
        de que pueda enterarse, se produzca o pudiera producirse en contra de la propiedad intelectual o
        inmaterial de Eficacia.</p>

    <p>Igualmente, la CLIENTE seguirá siendo titular de todos los derechos de propiedad intelectual o
        propiedad inmaterial relacionados o que se asocien a su modelo de negocio y por ningún motivo
        deberá entenderse que la suscripción de este contrato significa licencia alguna de Eficacia para el
        uso y/o comercialización de cualquiera de sus derechos de propiedad intelectual o inmaterial.
        El incumplimiento de cualquiera de las disposiciones señaladas en esta cláusula dará lugar a la
        terminación de este contrato.</p>


    </section>

    <!-- 10. Seguridad de la Información y Ciberseguridad -->
    <section>
        <h5>10. Seguridad de la Información y Ciberseguridad</h5>
        <p>
            Teniendo en cuenta que toda la información de la CLIENTE es uno de sus activos más importantes,
            Eficacia se sujetará a las siguientes obligaciones en materia de seguridad de la información y
            ciberseguridad:
        </p>
        <ol>
            <li><strong>10.1</strong> Establecer y mantener un programa de seguridad de la información, incluyendo seguridad
                de elementos físicos, digitales, virtuales, ciberespacio independiente de su tránsito y/o
                ubicación, el cual debe estar diseñado para:
            
                <ol>
                    <li><strong>10.1.1</strong> Garantizar la protección, la integralidad, disponibilidad y confidencialidad de toda la
                        información a la que se tenga acceso con ocasión de este contrato y de acuerdo con
                        su nivel de sensibilidad;</li>
                    <li><strong>10.1.2</strong>  Proteger de manera anticipada contra amenazas y/o riesgos que puedan llegar a
                        afectar la información a la que se tenga acceso con ocasión del servicio contratado;</li>
                    
                    <li><strong>10.1.3</strong>  Proteger contra el acceso o uso no autorizados de la INFORMACIÓN CONFIDENCIAL o
                        clasificada como DATOS PERSONALES, según el ordenamiento jurídico aplicable;</li>

                        <li><strong>10.1.4.</strong>  Garantizar que toda la información sea tratada conforme a los estándares de
                            seguridad aplicables.</li>
                </ol>
            </li>
            <li><strong>10.2</strong> Desarrollar procedimientos para gestionar cualquier incidente de acceso no autorizado
                y/o violación que amenace la seguridad de la INFORMACIÓN CONFIDENCIAL de la CLIENTE y/o
                DATOS PERSONALES y lo notificará de manera inmediata y oportuna al conocimiento del
                mismo;</li>
            <li><strong>10.3</strong> Modificar cuando lo crea conveniente sus procedimientos de seguridad de la información,
                incluyendo seguridad física, de conformidad con las normas aplicables y buenas prácticas
                de seguridad de la información</li>
            <li><strong>10.4</strong> Contar con dispositivos y herramientas de seguridad idóneos que protejan sus redes e
                infraestructura tecnológica;</li>
            
            <li><strong>10.5</strong> Establecer controles, herramientas y/o mecanismos para el borrado seguro y destrucción
                de la información conforme a las mejores prácticas de la industria y procedimientos y
                mecanismos para la devolución y entrega a la CLIENTE de toda la información a la que tuvo
                acceso durante la vigencia del servicio contratado;
            </li>
            <li><strong>10.6</strong> Dar inmediato aviso a la CLIENTE, sobre la ocurrencia de cualquier evento o circunstancia
                que altere el normal desarrollo y/o ejecución del servicio contratado. Igualmente, Eficacia
                se compromete a tomar los correctivos necesarios de manera inmediata cuando se detecte
                una alteración o manipulación no autorizada;
            </li>
            <li><strong>10.7</strong> Mantener controles de seguridad razonables y suficientes durante la ejecución de los
                servicios objeto de este contrato.
            </li>
            <li><strong>10.8</strong> Con la terminación del servicio contratado, cualquiera fuere su causa, Eficacia se
                compromete a devolver la base o las bases de datos con las condiciones de seguridad y
                entrega acordadas con la CLIENTE. Asimismo, deberá destruir toda copia que hubiere creado
                para la prestación de los servicios contratados.
            </li>
            <li><strong>10.9</strong> Ejecutar los procedimientos establecidos en las políticas de seguridad de la información
                implementadas como componente principal de su acreditación y/o certificación en
                estándares de seguridad de la información ISO 27001.
            </li>

        </ol>

        <p>Por su parte, la CLIENTE se sujetará a las siguientes obligaciones en materia de seguridad de la
            información y ciberseguridad:</p>

            <ol>
                <li><strong>10.10</strong> Mantener actualizado todo software o programa utilizado en el entorno asociado a la
                    APLICACIÓN SGI 4.0, incluyendo sistemas operativos, navegadores web y aplicaciones, con las
                    últimas versiones y parches de seguridad disponibles.
                </li>
                <li><strong>10.11</strong> Utilizar contraseñas robustas y únicas para acceder al servicio de SaaS. Se recomienda
                    que las contraseñas contengan una combinación de letras mayúsculas y minúsculas,
                    números y caracteres especiales, y que se cambien periódicamente.
                </li>
                <li><strong>10.12</strong> Implementar la autenticación de dos factores siempre que esté disponible, lo que
                    proporcionará una capa adicional de seguridad al requerir un segundo factor de
                    verificación.
                </li>
                <li><strong>10.13</strong> La CLIENTE asignará niveles de acceso y privilegios según las responsabilidades de cada
                    usuario, limitando el acceso solo a la información y funciones necesarias para desempeñar
                    sus tareas.
                </li>
                <li><strong>10.14</strong> Realizar copias de seguridad periódicas de los datos almacenados en el servicio SaaS,
                    asegurando su disponibilidad en caso de pérdida, corrupción o daño.
                </li>
                <li><strong>10.15</strong> Capacitar y concientizar a sus usuarios sobre las mejores prácticas de seguridad,
                    incluyendo la detección de correos electrónicos y enlaces sospechosos, el uso seguro de
                    contraseñas y la protección de información confidencial.
                </li>
                <li><strong>10.16</strong> La CLIENTE implementará soluciones de seguridad antivirus y antimalware actualizadas en
                    todos los dispositivos utilizados para acceder al servicio SaaS, para prevenir y detectar
                    posibles amenazas y Códigos Maliciosos.
                </li>
                <li><strong>10.17</strong> Establecer cortafuegos y filtrado de tráfico para controlar y bloquear el acceso no
                    autorizado a la red y al servicio SaaS, protegiendo así la información de los usuarios.
                </li>
                <li><strong>10.18</strong> Establecer medidas para controlar el acceso físico y lógico a los equipos, dispositivos y
                    sistemas utilizados para acceder al servicio de SaaS, garantizando que solo personal
                    autorizado pueda realizar dichos accesos.
                </li>
                <li><strong>10.19</strong> Implementar sistemas de detección de intrusiones para identificar y responder
                    rápidamente a posibles ataques o actividades sospechosas que puedan comprometer la
                    seguridad del servicio SaaS.
                </li>
                <li><strong>10.20</strong> Realizar evaluaciones periódicas de riesgos para identificar posibles vulnerabilidades y
                    establecer medidas adicionales de seguridad que sean necesarias para proteger la
                    información de los usuarios y mantener la integridad del servicio SaaS.
                </li>
            </ol>
        
    </section>

    <!-- 11. Confidencialidad -->
    <section>
        <h5>11. Confidencialidad</h5>
        <p>En virtud de este contrato, la CLIENTE se obliga a no revelar, divulgar, exhibir, mostrar, comunicar,
            utilizar, usar y/o emplear la INFORMACIÓN CONFIDENCIAL asociada a la APLICACIÓN SGI 4.0, a los productos
            y servicios, al modelo de negocio y la información precontractual y contractual como reportes,
            entregables, cronogramas de capacitaciones, datos del negocio y aplicación comercial, el
            TRATAMIENTO que realice sobre bases de datos y/o DATOS PERSONALES, entre otros, que por razón o
            con ocasión de la relación contractual entre las partes estas se compartan, a sus empleados,
            contratistas, clientes o usuarios autorizados, excepto cuando esto sea estrictamente necesario para
            usar la APLICACIÓN SGI 4.0 y solamente después de haber firmado el respectivo acuerdo o contrato de
            confidencialidad.</p>
        <p>La CLIENTE se obliga y compromete a firmar y hacer firmar los acuerdos o contratos de
            confidencialidad con cada persona autorizada para tener acceso a la APLICACIÓN SGI 4.0 y los cuales
            deberán contener como mínimo los mismos términos, alcance y condiciones de confidencialidad
            de este contrato.</p>
        <p>
            Las partes se obligan a no usar la INFORMACIÓN CONFIDENCIAL para algún otro propósito que no se
        relacione con el fin de este contrato, así como no hacer un aprovechamiento no autorizado, para
        beneficio propio o de terceros, de toda o parte de la INFORMACIÓN CONFIDENCIAL. En consecuencia, las
        partes mantendrán la INFORMACIÓN CONFIDENCIAL que reciban de la otra de manera reservada y
        privada y a proteger dicha información para evitar su divulgación no autorizada, ejerciendo sobre
        esta el mismo grado de diligencia que utiliza para proteger la información técnica, know how y
        secretos empresariales de su propiedad. Asimismo, las partes se obligan a destruir todas las copias
        de la INFORMACIÓN CONFIDENCIAL de la otra parte a la que hayan tenido acceso al momento de la
        terminación de este contrato.
        </p>
        <p>
            La CLIENTE garantiza que empleará las medidas técnicas, jurídicas y organizativas, entre ellos la
        suscripción de acuerdos de confidencialidad con sus trabajadores y proveedores a fin de garantizar
        el cumplimiento de lo dispuesto en esta cláusula.
        Eficacia aplicará todas las medidas de seguridad razonables para evitar la revelación, acceso o uso
        no autorizado de la INFORMACIÓN CONFIDENCIAL, y en especial de los DATOS DE LA CLIENTE y aplicará las
        medidas razonables necesarias para su protección con la misma diligencia con la que protege su
        propia información confidencial.
        </p>
        <p>
            En caso de que alguna de las partes, su personal, sus asesores o subcontratistas sean legal o
        judicialmente requeridos a revelar cualquier INFORMACIÓN CONFIDENCIAL relacionada a este contrato
        y a su ejecución, deberán notificar esta circunstancia a la parte titular de la INFORMACIÓN CONFIDENCIAL
        inmediatamente para que ésta pueda tomar las medidas necesarias para cautelar su derecho a la
        privacidad. Si la interposición de una medida de defensa no procede y/o si la parte, su personal, sus
        asesores o subcontratistas están, en opinión de sus abogados, obligados a revelar información
        confidencial bajo responsabilidad o sanción, podrán revelar únicamente la parte de la información
        confidencial que legalmente se requiera sin que constituya incumplimiento de este contrato;
        siempre que acuerden utilizar sus mejores esfuerzos para asegurar que la información será tratada
        confidencialmente.
        </p>
    </section>

    <!-- 12. Limitaciones a la Responsabilidad -->
    <section>
        <h5>12. Limitaciones a la Responsabilidad</h5>
        <p>
            En virtud de este contrato, las partes declaran y aceptan que:
        </p>
        <ol>
            <li>
                <strong>12.1</strong> Eficacia no será responsable por los daños que se le causen a la CLIENTE, sus negocios o
                actividades económicas o empresariales, sus empleados, contratistas, socios, aliados y/o
                clientes por razón, como resultado o por ocasión del uso indebido, por fuera del alcance
                de este contrato, no autorizado, delictivo, ilícito o ilegal de la APLICACIÓN SGI 4.0.
            </li>
            <li>
                <strong>12.2</strong> La CLIENTE acepta, entiende y acuerda que Eficacia no será responsable por la instalación y
                uso que se realice de la APLICACIÓN SGI 4.0 en los dispositivos de los USUARIOS.
            </li>
            <li>
                <strong>12.3</strong> La CLIENTE acepta, acuerda y entiende que deberá indemnizar a Eficacia por cualquier daño
                o perjuicio causado, incluyendo daños en su reputación o las de sus marcas, por razón de
                las demandas, acciones judiciales, arbitrales o extrajudiciales, iniciadas en su contra o
                cualquier sentencia, condena, indemnización, pago de perjuicios o reparación a la que sea
                condenada o sentenciada.
            </li>
            <li>
                <strong>12.4</strong> La CLIENTE acepta y acuerda que Eficacia no será responsable por el incumplimiento de
                expectativas o resultados comerciales, de venta, de mercadeo, técnicas o de negocios que
                no se materialicen o se no obtengan, en todo o en parte, por la CLIENTE por razón del uso y
                acceso a la APLICACIÓN SGI 4.0. Igualmente, los daños que se le causen a la CLIENTE, sus
                negocios o actividades económicas o empresariales, sus empleados, contratistas, socios,
                aliados y/o clientes por razón, como resultado, o por ocasión del uso de la APLICACIÓN SGI 4.0
                son responsabilidad única y exclusiva de la CLIENTE.
            </li>
            <li>
                <strong>12.5</strong> La CLIENTE entiende y acepta que por ningún motivo podrá considerarse que habrá
                responsabilidad de Eficacia si por las circunstancias que se especifican en este contrato no
                puede acceder, usar o ejecutar la APLICACIÓN SGI 4.0.
            </li>
            <li>
                <strong>12.6</strong> En cualquier caso, si Eficacia es demandada o resulta condenada como resultado de
                acciones judiciales, arbitrales o extrajudiciales en su contra iniciadas por la CLIENTE, sus
                empleados, contratistas, socios, aliados, clientes o terceros por razón de daños causados
                por el uso indebido, por fuera del alcance de este contrato SaaS, no autorizado, delictivo,
                ilícito o ilegal de la APLICACIÓN SGI 4.0, la CLIENTE acuerda, acepta y entiende que deberá salir
                en defensa y/o asumir la defensa (incluyendo los costos de honorarios de abogados) y
                podrá ser llamado en garantía para atender, defender y mantener indemne a Eficacia,
                incluyendo pagar en nombre o en reemplazo de Eficacia, por cualquier condena,
                indemnización, pago de perjuicios o reparación al que sea condenado, sentenciado o
                impuesta a Eficacia.
            </li>
            <li>
                <strong>12.7</strong> Si por cualquier circunstancia Eficacia llegara a ser responsable en virtud de este contrato,
                la responsabilidad de Eficacia bajo este contrato, sin importar la forma o clase de acción,
                no excederá los montos pagados por la CLIENTE bajo este contrato en los doce (12) meses
                anteriores a la demanda o reclamación. Eficacia no será responsable por ningún daño
                especial, indirecto, consecuente o incidental que surja de la ejecución de este contrato y/o
                el servicio prestado, sin importar si la parte ha sido notificada la posibilidad de ocurrencia
                de tales daños.
            </li>
            <li>
                <strong>12.8</strong> Las partes se liberan de responsabilidad por aquellos hechos u omisiones que sean
                producto de eventos de fuerza mayor o caso fortuito. Las partes convienen en definir como
                fuerza mayor y caso fortuito aquellos hechos de la naturaleza o de los hombres que se
                encuentren fuera del control racional de las partes, que no puedan ser previstos y si
                previstos no puedan ser evitados siempre que tales hechos no deriven de acto doloso o
                negligencia de la parte que lo invoca o de sus dependientes. <br>

                Sin tener carácter limitativo sino simplemente comunicativo, se consideran causas de
                fuerza mayor las catástrofes naturales, los casos de terremotos, maremotos,
                deslizamientos, aluviones, desbordes de ríos, inundaciones, ciberataques, pandemias. Se
                consideran asimismo como Caso Fortuito los siguientes: guerra, insurrecciones, motines,
                vandalismo, golpes de Estado, huelga etc. Las causas de fuerza mayor para ser invocadas
                deberán afectar directamente al servicio o impedir su cumplimiento. <br>

                La parte afectada por una causal de fuerza mayor o caso fortuito deberá comunicar
                inmediatamente de la ocurrencia del hecho y acreditar tal hecho a más tardar dentro de
                las veinticuatro (24) horas de producido. Vencido dicho plazo se tendrá como inexistente
                el caso fortuito o de fuerza mayor. Sin perjuicio de ello, las partes deben contar con copias
                de seguridad a fin de evitar pérdidas de información debido a fallas técnicas, por el uso
                indebido o no autorizado de la plataforma o escenarios no eventuales ni imprevistos.
            </li>


        </ol>
    </section>

    <!-- 13. Tratamiento de Datos Personales -->
    <section>
        <h5>13. Tratamiento de Datos Personales</h5>
        <p>
            La CLIENTE reconoce que la suscripción de este contrato, la ejecución de sus obligaciones y la
            utilización de la APLICACIÓN SGI 4.0 dan lugar a que Eficacia acceda y trate DATOS PERSONALES que se
            encuentren bajo la responsabilidad de la CLIENTE. Los DATOS PERSONALES que se recolecten y traten por
            medio de la APLICACIÓN SGI 4.0 seguirán lo establecido en el documento denominado «Convenio de
            protección de datos personales» que se encuentra incorporado en el anexo C de este contrato y que
            hace parte íntegra del mismo y por lo tanto es de obligatorio cumplimiento para las partes.
        </p>
    </section>

    <!-- 14. Datos de la CLIENTE -->
    <section>
        <h5>14. Datos de la CLIENTE</h5>
        <p>
            La CLIENTE reconoce que es titular toda la información que introduce en la APLICACIÓN SGI 4.0 o que se
            encuentra autorizada para el tratamiento de los datos que almacene en la misma o se entreguen a
            través de cualquier INTERFAZ DE PROGRAMACIÓN DE APLICACIONES (API) y que se entienden como los
            DATOS DE LA CLIENTE. Eficacia tratará todos los DATOS DE LA CLIENTE como confidenciales y solo podrá
            utilizarlos para (i) garantizar el servicio y las funcionalidades de la Plataforma para la CLIENTE, (ii)
            utilizar información agregada y/o anónima para mejorar sus servicios, desarrollar nuevos servicios,
            mostrar tendencias de uso general de los servicios, obtener información relevante del mercado,
            proporcionar consultorías especializadas o entrega al mercado de información anonimizada, en
            referencia a canales, sectores, categorías, subcategorías, variaciones de precios, ubicaciones o
            sectores, ciudades, barrios, entre otros, así como para el análisis estadístico y decisiones
            comerciales la APLICACIÓN SGI 4.0, (iii) supervisar el uso de la APLICACIÓN SGI 4.0 por parte de la CLIENTE
            para fines de seguridad, de soporte técnico y para la validación de cumplimiento y limitaciones de
            uso de la CLIENTE, así como para cumplir, de cualquier otra manera, con las obligaciones de Eficacia
            con la CLIENTE.
        </p>
    </section>

    <!-- 15. Terminación del Contrato -->
    <section>
        <h5>15. Terminación del Contrato</h5>
        <p>
            Sin perjuicio de las causales de resolución expresa regulados en este contrato, este negocio podrá
            ser resuelto por cualesquiera de las partes en caso la otra incumpla con alguna de sus obligaciones
            asumidas por este Contrato, bastando para ello el envío de una comunicación a la parte incumplida,
            requiriéndole el cumplimiento de su obligación dentro de los quince (15) días siguientes a la
            notificación; siendo que transcurrido dicho plazo sin que se haya verificado el fiel cumplimiento de
            la misma, el Contrato quedará automáticamente resuelto.
            Adicionalmente, este contrato podrá terminarse de forma anticipada por las siguientes causales:
        </p>
        <ol>
            <li> <strong>15.1</strong> Por mutuo acuerdo entre las partes;</li>
            <li> <strong>15.2</strong> Por vencimiento y no renovación de la MEMBRESÍA.</li>
            <li> <strong>15.3</strong> Por la existencia de un supuesto que califique como «caso fortuito» o «fuerza mayor» e
                impida la ejecución de los SERVICIOS por un periodo mayor a 45 días</li>
        </ol>
        <p>
            Eficacia podrá declarar resuelto de pleno derecho este contrato, comunicando su decisión de
            resolver el Contrato mediante comunicación dirigida a la CLIENTE, indicando la naturaleza del
            incumplimiento:
        </p>
        <ol>
        <li><strong>15.4</strong> Porque la CLIENTE incumplió sus obligaciones de pago de la Membresía.</li>
        <li><strong>15.5</strong> Porque la CLIENTE vulnera los derechos de propiedad intelectual o inmaterial de Eficacia o de terceros.</li>
        <li><strong>15.6</strong> Porque la CLIENTE incumpla con sus obligaciones de confidencialidad y reserva de la INFORMACIÓN CONFIDENCIAL de Eficacia.</li>
        <li><strong>15.7</strong> Porque la CLIENTE incumplió sus obligaciones de Seguridad de la Información.</li>
        <li><strong>15.8</strong> Porque la CLIENTE incumple con sus obligaciones en materia de protección de datos personales.</li>
        <li><strong>15.9</strong> Cuando la CLIENTE solicite voluntariamente, sea requerida por la autoridad competente o deba someterse a un proceso de reorganización, liquidación, insolvencia, quiebra, orden de embargo o de secuestro de bienes, suspensión de pagos u otra situación a su cargo que pueda tener algún impacto o afectación en la ejecución o cumplimiento de una o más obligaciones acordadas en este contrato.</li>
        <li><strong>15.10</strong> Cuando los bienes de la CLIENTE o de sus socios o aliados sean relacionados en requerimientos de entidades de control, noticias, tanto a nivel nacional como internacional, por la presunta comisión de delitos fuentes de Lavado de Activos y Financiación del Terrorismo (LAFT).</li>
        <li><strong>15.11</strong> Cuando la CLIENTE, sus socios o aliados sean condenados por parte de las autoridades competentes en cualquier tipo de proceso judicial relacionado con la comisión de los anteriores delitos, sean sancionados o sea incluidos en las listas del SARLAC, FBI, OEA o demás organizaciones nacionales, multinacionales o internacionales o llevar a cabo actividades o acciones que lo vinculen con el lavado de activos, terrorismo, financiación o encubrimiento del terrorismo o la corrupción.</li>  <li>La CLIENTE incumple sus obligaciones de pago.</li>
        </ol>
        <p>
            <strong>Parágrafo primero.</strong>La terminación de este contrato no será excusa para que las partes no cumplan
            con las demás obligaciones contenidas en el mismo y que sobrevivan a su terminación, incluyendo
            cualquier obligación de confidencialidad, económica, de dar, hacer o no hacer que se encuentre
            pendiente.
        </p>
        <p>
            <strong>Parágrafo segundo. </strong>
            Las obligaciones de la CLIENTE contenidas en este contrato con relación al
            tratamiento, uso, reserva y demás de la INFORMACIÓN CONFIDENCIAL se mantendrán vigentes durante
            el plazo de este contrato, posterior a su terminación (por cualquiera de sus causales) y aún después
            de vencido el término de vigencia y hasta cuando la INFORMACIÓN CONFIDENCIAL deje de ser
            confidencial o secreta. Cuando la información suministrada por Eficacia a la CLIENTE o viceversa
            constituya secretos empresariales, esta obligación permanecerá mientras conserven tal calidad. Su
            incumplimiento durante el término de vigencia o aún después de terminado el contrato podrán dar
            lugar al pago de indemnizaciones por los perjuicios causados y las demás acciones civiles, penales
            o administrativas que haya lugar de acuerdo con la ley nacional, andina o internacional a elección
            de la parte cumplida.
        </p>
    </section>

    <!-- 16. Empresa Conjunta -->
    <section>
        <h5>16. Empresa Conjunta</h5>
        <p>
            Este contrato no establece una empresa conjunta, asociación, sociedad de hecho entre las partes y,
            en ningún caso, las partes informarán a otras personas de la conformación de una empresa
            conjunta, asociación, sociedad de hecho, a menos que dicha entidad se haya formado como
            consecuencia de un contrato debidamente acordado y suscrito por las partes.
        </p>
    </section>

    <!-- 17. No Relación Laboral -->
    <section>
        <h5>17. No Relación Laboral</h5>
        <p>
            Las partes declaran de manera expresa que entre Eficacia y las personas que intervengan por
            cuenta y cargo exclusivo de la CLIENTE en la ejecución de este contrato no existe ningún vínculo o
            relación laboral.
            Debido a lo anterior, la CLIENTE se obliga, según sea el caso, a sacar en paz y salvo a Eficacia de
            cualquier acción, demanda, denuncia, proceso, juicio, controversia, requerimiento, notificación,
            liquidación, laudo o sentencia emitida por alguna autoridad, promovida por los empleados, clientes,
            contratistas, proveedores o terceros con negocios con la CLIENTE, incluyendo procesos por causas
            de lesión, afectación, muerte, daño a propiedad, sea o no en función de este contrato.
        </p>
    </section>

    <!-- 18. Nulidad Parcial del Contrato -->
    <section>
        <h5>18. Nulidad Parcial del Contrato</h5>
        <p>
            as partes aceptan, entienden y acuerdan que en el evento de que algún término, concepto,
            obligación, cláusula o parte de este contrato sea declarado nulo, inválido, ilegal o no aplicable, la
            validez del resto del contrato permanecerá intacta y será de obligatorio cumplimiento para las
            partes y podrá ser judicial o extrajudicialmente exigido a la otra parte.
        </p>
    </section>

    <!-- 19. Prohibición de Cesión -->
    <section>
        <h5>19. Prohibición de Cesión</h5>
        <p>
            Las partes aceptan, entienden y acuerdan que este contrato impone obligaciones personalísimas y
            que por lo tanto no podrá ser cedido a terceros sin la autorización previa, expresa y por escrito de
            la otra parte.
        </p>
    </section>

    <!-- 20. Modificaciones -->
    <section>
        <h5>20. Modificaciones</h5>
        <p>
            No se admitirán modificaciones a este contrato sin el consentimiento escrito y previo de las partes.
Ningún comportamiento ni curso de acción adoptado por las partes será interpretado como una
modificación, ya sea expresa o implícita, a cualesquiera de las disposiciones de este contrato.
        </p>
    </section>

    <!-- 21. Requerimientos Funcionales y Técnicos -->
    <section>
        <h5>21. Requerimientos Funcionales y Técnicos</h5>
        <p>
            Los requerimientos funcionales y técnicos se encuentran detallados en el anexo A.
Las partes acuerdan que, salvo acuerdo expreso y requerimiento previo de la CLIENTE en torno a un
requerimiento funcional y técnico respecto de la APLICACIÓN SGI 4.0, la CLIENTE se compromete a no
exigir a Eficacia cuestiones específicas relacionadas con el diseño funcional o técnico del Software.
La CLIENTE reconoce y acepta que Eficacia posee la experiencia y el conocimiento necesarios para
desarrollar y proveer el servicio SaaS de manera adecuada.
Cualquier solicitud relacionada con cambios o mejoras en el diseño funcional o técnico del producto
deberá ser comunicada por la CLIENTE a Eficacia a través de un proceso de solicitud de modificación
acordado entre las partes.
Eficacia evaluará las solicitudes de modificación presentadas por la CLIENTE y determinará, a su
entera discreción, si las implementará. En caso de aceptar la solicitud de modificación, ambas partes
acordarán por escrito los términos y condiciones específicos, así como cualquier impacto en el plazo
y la contraprestación acordada en este contrato.
La CLIENTE se compromete a no realizar modificaciones, alteraciones o interferencias en el diseño
funcional o técnico del producto sin el consentimiento previo y por escrito del Proveedor. Cualquier
modificación no autorizada realizada por la CLIENTE será responsabilidad exclusiva del mismo y podrá
dar lugar a la terminación anticipada del contrato o a la reclamación por daños y perjuicios por parte
de Eficacia.
La CLIENTE comprende y acepta que el diseño funcional o técnico del producto puede evolucionar a
lo largo del tiempo, y que Eficacia tiene la facultad de realizar actualizaciones, mejoras y cambios en
función de las necesidades del mercado, los avances tecnológicos y otros factores relevantes.
La exclusión de exigencias específicas sobre el diseño funcional o técnico no limita las obligaciones
de Eficacia de cumplir con los niveles de servicio acordados, las garantías y otros compromisos
establecidos en este contrato.
Cualquier acuerdo adicional relacionado con el diseño funcional o técnico deberá ser plasmado por
escrito y adjuntado como anexo a este contrato, prevaleciendo sobre cualquier disposición en
conflicto.
        </p>
    </section>

    <!-- 22. Ley Aplicable -->
    <section>
        <h5>22. Ley Aplicable</h5>
        <p>
            Este contrato SaaS se rige por la ley colombiana y deberá ser interpretado de acuerdo con las leyes
colombianas y la jurisprudencia aplicable
        </p>
    </section>

    <!-- 23. Resolución de Conflictos -->
    <section>
        <h5>23. Resolución de Conflictos</h5>
        <p>
            Toda controversia o diferencia relativa a este contrato intentará ser resuelta por las partes de
manera amigable. Sin embargo, si no fuera posible llegar a un fin del conflicto de forma amigable,
este deberá ser resuelto en primera instancia por conciliación entre las partes ante el Centro de
Conciliación de la Cámara de Comercio de Cali, Valle del Cauca. De no ser posible llegar a un
acuerdo, las partes acuerdan que acudirán a la justicia ordinaria
        </p>
    </section>

    <!-- 24. Notificaciones -->
    <section>
        <h5>24. Notificaciones</h5>
        <p>
            Toda notificación, requerimiento, comunicación o información entre las partes se surtirá a través
de la siguiente información de contacto en caso de requerimientos por fuera del software.
        </p>
        <table border="1" cellspacing="0" cellpadding="5">
            <tr>
                <th>Por Parte de la CLIENTE</th>
                <th>Por Parte de Eficacia</th>
            </tr>
            <tr>
                <td>
                    Nombre de la persona de contacto<br>
                    Correo Electrónico<br>
                    Dirección
                </td>
                <td>
                    Nombre de la persona de contacto<br>
                    Correo Electrónico<br>
                    Dirección
                </td>
            </tr>
        </table>
    </section>

    <!-- 25. Firma a través de medios electrónicos -->
    <section>
        <h5>25. Firma a través de Medios Electrónicos</h5>
        <p>
            Las partes acuerdan que este documento sea firmado a través de plataformas de firma electrónica.
En este sentido, las partes entienden que las mencionadas plataformas de firma electrónica resultan
confiables y apropiadas para el propósito de identificar a las personas que firman este documento
y su intención de obligarse en los términos del mismo. Las partes declaran y entienden que esta
firma electrónica tendrá la misma validez y efectos jurídicos que la firma manuscrita.
Para efectos de lo dispuesto en esta cláusula las partes establecen las siguientes direcciones
electrónicas:
        </p>
        <p>
            <strong>La CLIENTE:</strong> [completar]<br>
            <strong>Eficacia:</strong> rocio_maldonado@eficacia.com.co
        </p>
    </section>

</div>
